import PropTypes from "prop-types";

export default function createResponsivePropType(arrayValue) {
    const oneOf = PropTypes.oneOf(arrayValue);
    const propType = PropTypes.oneOfType([oneOf, PropTypes.arrayOf(oneOf)]);

    return propType;
}
